import React from 'react';
import { Card, CardContent, CardHeader, Checkbox, Stack, TextField, Typography } from '@mui/material';

import { formatDate } from '../../../../../../../services/functions';
import { SmallFormDateField } from '../../../../../../../components/small-fields/SmallFormDateField';

const BaseDataForm = ({ formik, manual, type }) => (
  <Stack flexDirection="column" justifyContent="space-between">
    {manual
      ? <SmallFormDateField
        standardTextField
        name="sale_date"
        id="sale_date"
        type="text"
        label="Data księgowania"
        placeholder="data księgowania"
        value={formik.values.sale_date}
        onChange={val => formik.setFieldValue('sale_date', formatDate(val))}
        error={Boolean(formik.errors.sale_date)}
        helperText={formik.touched.sale_date && formik.errors.sale_date}
        sx={{ width: '100%', maxWidth: null, ml: 3, pr: 6 }}
      />
      : null
    }
    <Stack flexDirection="row" justifyContent="space-between">
      <Card sx={{ flexGrow: 0.48 }}>
        <CardHeader title="Sprzedawca" />
        <CardContent>
          <Stack spacing={2}>
            <TextField
              id="seller_company_name"
              size="small"
              label="Nazwa firmy"
              value={formik.values.seller_company_name}
              onChange={formik.handleChange}
              error={formik.errors.seller_company_name && formik.touched.seller_company_name}
              helperText={formik.errors.seller_company_name}
            ></TextField>
            <TextField id="seller_name" size="small" label="Imię i nazwisko" value={formik.values.seller_name} onChange={formik.handleChange}></TextField>
            <TextField
              id="seller_street_address"
              size="small"
              label="Ulica i numer"
              value={formik.values.seller_street_address}
              onChange={formik.handleChange}
              error={formik.errors.seller_street_address && formik.touched.seller_street_address}
              helperText={formik.errors.seller_street_address}
            ></TextField>
            <TextField
              id="seller_postal_code"
              size="small"
              label="Kod pocztowy"
              value={formik.values.seller_postal_code}
              onChange={formik.handleChange}
              error={formik.errors.seller_postal_code && formik.touched.seller_postal_code}
              helperText={formik.errors.seller_postal_code}
            ></TextField>
            <TextField
              id="seller_city"
              size="small"
              label="Miasto"
              value={formik.values.seller_city}
              onChange={formik.handleChange}
              error={formik.errors.seller_city && formik.touched.seller_city}
              helperText={formik.errors.seller_city}
            ></TextField>
            <TextField id="seller_nip" size="small" label="NIP" value={formik.values.seller_nip} onChange={formik.handleChange}></TextField>
            <TextField
              id="bank_name"
              size="small"
              label="Nazwa banku"
              value={formik.values.bank_name}
              onChange={formik.handleChange}
            ></TextField>
            <TextField
              id="account_number"
              size="small"
              label="Numer konta"
              value={formik.values.account_number}
              onChange={formik.handleChange}
            ></TextField>
          </Stack>
        </CardContent>
      </Card>
      <Card sx={{ flexGrow: 0.48 }}>
        <CardHeader title="Nabywca" />
        <CardContent>
          <Stack spacing={2}>
            <TextField
              id="buyer_name"
              size="small"
              label="Imię i nazwisko"
              value={formik.values.buyer_name}
              onChange={formik.handleChange}
              error={formik.errors.buyer_name && formik.touched.buyer_name}
              helperText={formik.errors.buyer_name}
            ></TextField>
            <TextField
              id="buyer_street_address"
              size="small"
              label="Uilca i numer"
              value={formik.values.buyer_street_address}
              onChange={formik.handleChange}
              error={formik.errors.buyer_street_address && formik.touched.buyer_street_address}
              helperText={formik.errors.buyer_street_address}
            ></TextField>
            <TextField
              id="buyer_postal_code"
              size="small"
              label="Kod pocztowy"
              value={formik.values.buyer_postal_code}
              onChange={formik.handleChange}
              error={formik.errors.buyer_postal_code && formik.touched.buyer_postal_code}
              helperText={formik.errors.buyer_postal_code}
            ></TextField>
            <TextField
              id="buyer_city"
              size="small"
              label="Miasto"
              value={formik.values.buyer_city}
              onChange={formik.handleChange}
              error={formik.errors.buyer_city && formik.touched.buyer_city}
              helperText={formik.errors.buyer_city}
            ></TextField>
            <TextField id="buyer_nip" size="small" label="NIP" value={formik.values.buyer_nip} onChange={formik.handleChange}></TextField>
          </Stack>
        </CardContent>
      </Card>
      { [1, 2, 3, 4].includes(type)
        ? <Card sx={{ flexGrow: 0.48 }}>
          <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
            <Checkbox
              checked={formik.values.include_recipient}
              onChange={formik.handleChange}
              name="include_recipient"
              label="Uwzględnij odbiorcę"
            />
            <Typography variant="subtitle2">Uwzględnij odbiorcę</Typography>
          </Stack>
          { formik.values.include_recipient
            ? <>
              <CardHeader title="Odbiorca" />
              <CardContent>
                <Stack spacing={2}>
                  <TextField
                    id="recipient_name"
                    size="small"
                    label="Imię i nazwisko"
                    value={formik.values.recipient_name}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_name && formik.touched.recipient_name}
                    helperText={formik.errors.recipient_name}
                  ></TextField>
                  <TextField
                    id="recipient_street_address"
                    size="small"
                    label="Uilca i numer"
                    value={formik.values.recipient_street_address}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_street_address && formik.touched.recipient_street_address}
                    helperText={formik.errors.recipient_street_address}
                  ></TextField>
                  <TextField
                    id="recipient_postal_code"
                    size="small"
                    label="Kod pocztowy"
                    value={formik.values.recipient_postal_code}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_postal_code && formik.touched.recipient_postal_code}
                    helperText={formik.errors.recipient_postal_code}
                  ></TextField>
                  <TextField
                    id="recipient_city"
                    size="small"
                    label="Miasto"
                    value={formik.values.recipient_city}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_city && formik.touched.recipient_city}
                    helperText={formik.errors.recipient_city}
                  ></TextField>
                  <TextField
                    id="recipient_nip"
                    size="small"
                    label="NIP"
                    value={formik.values.recipient_nip}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_nip && formik.touched.recipient_nip}
                    helperText={formik.errors.recipient_nip}>
                  </TextField>
                </Stack>
              </CardContent>
            </> : null}
        </Card> : null}
      { type === 10
        ? <Card sx={{ flexGrow: 0.48 }}>
          {!formik.values.special
            ? <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
              <Checkbox
                checked={formik.values.include_recipient}
                onChange={formik.handleChange}
                name="include_recipient"
                label="Uwzględnij odbiorcę"
              />
              <Typography variant="subtitle2">Uwzględnij odbiorcę</Typography>
            </Stack> : null}
          { formik.values.include_recipient
            ? <>
              <CardHeader title="Odbiorca" />
              <CardContent>
                <Stack spacing={2}>
                  <TextField
                    id="recipient_name"
                    size="small"
                    label="Imię i nazwisko"
                    value={formik.values.recipient_name}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_name && formik.touched.recipient_name}
                    helperText={formik.errors.recipient_name}
                  ></TextField>
                  <TextField
                    id="recipient_street_address"
                    size="small"
                    label="Uilca i numer"
                    value={formik.values.recipient_street_address}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_street_address && formik.touched.recipient_street_address}
                    helperText={formik.errors.recipient_street_address}
                  ></TextField>
                  <TextField
                    id="recipient_postal_code"
                    size="small"
                    label="Kod pocztowy"
                    value={formik.values.recipient_postal_code}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_postal_code && formik.touched.recipient_postal_code}
                    helperText={formik.errors.recipient_postal_code}
                  ></TextField>
                  <TextField
                    id="recipient_city"
                    size="small"
                    label="Miasto"
                    value={formik.values.recipient_city}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_city && formik.touched.recipient_city}
                    helperText={formik.errors.recipient_city}
                  ></TextField>
                  <TextField
                    id="recipient_nip"
                    size="small"
                    label="NIP"
                    value={formik.values.recipient_nip}
                    onChange={formik.handleChange}
                    error={formik.errors.recipient_nip && formik.touched.recipient_nip}
                    helperText={formik.errors.recipient_nip}>
                  </TextField>
                </Stack>
              </CardContent>
            </> : formik.values.special ? <><CardHeader title="Płatnik" /><CardContent>
              <Stack spacing={2}>
                <TextField
                  id="payer_name"
                  size="small"
                  label="Nazwa"
                  value={formik.values.payer_name}
                  onChange={formik.handleChange}
                  error={formik.errors.payer_name && formik.touched.payer_name}
                  helperText={formik.errors.payer_name}
                ></TextField>
                <TextField
                  id="payer_street_address"
                  size="small"
                  label="Uilca i numer"
                  value={formik.values.payer_street_address}
                  onChange={formik.handleChange}
                  error={formik.errors.payer_street_address && formik.touched.payer_street_address}
                  helperText={formik.errors.payer_street_address}
                ></TextField>
                <TextField
                  id="payer_postal_code"
                  size="small"
                  label="Kod pocztowy"
                  value={formik.values.payer_postal_code}
                  onChange={formik.handleChange}
                  error={formik.errors.payer_postal_code && formik.touched.payer_postal_code}
                  helperText={formik.errors.payer_postal_code}
                ></TextField>
                <TextField
                  id="payer_city"
                  size="small"
                  label="Miasto"
                  value={formik.values.payer_city}
                  onChange={formik.handleChange}
                  error={formik.errors.payer_city && formik.touched.payer_city}
                  helperText={formik.errors.payer_city}
                ></TextField>
                <TextField
                  id="payer_nip"
                  size="small"
                  label="NIP"
                  value={formik.values.payer_nip}
                  onChange={formik.handleChange}
                  error={formik.errors.payer_nip && formik.touched.payer_nip}
                  helperText={formik.errors.payer_nip}>
                </TextField>
              </Stack>
            </CardContent></> : null}
        </Card> : null}
    </Stack>
  </Stack>
);

export default BaseDataForm;
